import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import dynamic from 'next/dynamic';
import RootLayout from 'layouts/RootLayout';
import styles from 'pages/resources/privacy-policy/PrivacyPolicy.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Resources/PrivacyPolicy/components/SectionHeader'));
const SectionContent = dynamic(() => import('sections/Resources/PrivacyPolicy/components/SectionContent'));

export default function PrivacyPolicy() {
  return (
    <div className={cn('privacy-policy')}>
      <SectionHeader /> 
      <SectionContent /> 
    </div>
  );
}

export const getStaticProps = async () => {
  return {
    props: {
      title: 'Review Our Privacy Policy Online | DF Alliance',
      description: 'Review DF Alliance\'s Privacy Policy to understand how your personal data is handled and protected while using our global logistics services.',
      path: '/resources/privacy-policy',
    },
  };
};

PrivacyPolicy.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
